import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import Heading from '@bibliocommons/heading';
import { ExpandableHtml } from '@bibliocommons/expandable';
import { ChevronLink } from '@bibliocommons/base-links';
import { reviewShape } from '@bibliocommons/bc-prop-types';
import ShortFormattedDate from 'app/components/shared/ShortFormattedDate';
import { CONTENT_PROVIDERS } from 'app/constants/BibConstants';

import './Review.scss';

export default function Review({ review, compact }) {
  function renderCollapsedReview() {
    return (
      <ExpandableHtml
        htmlText={review.get('contents')}
        truncateCount={240}
        dataKey="critics-reviews"
        expandLinkHref={`#read-more-review-${review.get('id')}`}
        textKey="review"
      />
    );
  }

  function renderExpandedReview() {
    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: review.get('contents') }} />;
  }

  function renderReviewText() {
    // Don't collapse iDreamBooks reviews since they will always be short
    if (review.get('providerURI') === CONTENT_PROVIDERS.I_DREAM_BOOKS) return renderExpandedReview();
    return renderCollapsedReview();
  }

  const className = cn('cp-bib-review', { 'cp-bib-review--compact': compact });

  return (
    <div className={className}>
      <Heading tagName="h4" size="modest" className="review-source">
        {review.get('source')}
      </Heading>
      {!compact && <ShortFormattedDate value={review.get('reviewDate')} />}
      {renderReviewText()}
      {review.get('reviewLink') && (
        <ChevronLink href={review.get('reviewLink')} className="full-review" dataKey="display-full-review">
          <FormattedMessage id="full_review" />
        </ChevronLink>
      )}
    </div>
  );
}

Review.propTypes = {
  review: reviewShape.isRequired,
  compact: PropTypes.bool
};
